/** Single source for skills shown in Home orbit and Skills section */
export const portfolioSkills = [
  { id: "1", logo: "/images/html.png", name: "Html" },
  { id: "2", logo: "/images/css-3.png", name: "Css" },
  { id: "3", logo: "/images/js.png", name: "Javascript" },
  { id: "4", logo: "/images/git-logo.png", name: "Git" },
  { id: "5", logo: "/images/bootstrap.png", name: "Bootstrap" },
  { id: "6", logo: "/images/react.png", name: "React" },
  { id: "7", logo: "/images/redux.png", name: "Redux" },
  { id: "8", logo: "/images/aws.png", name: "AWS" },
];
